import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Icone } from './Icone';

/**
 * Tuile du tableau de bord (charte, § 6.8) : un chiffre clé qui ouvre l'écran
 * où il se détaille, déjà filtré sur ce qu'il compte.
 *
 * Sans `lien` — écran hors d'atteinte du rôle — la tuile reste un simple
 * chiffre, sans chevron : on ne promet pas une porte qui refuserait d'ouvrir.
 */
export function Tuile({
  titre,
  valeur,
  lien,
  alerte = false,
  appoint,
}: {
  titre: string;
  valeur: ReactNode;
  lien?: string;
  /** Situation à arbitrer : filet ambre et mention « à traiter ». */
  alerte?: boolean;
  /** Précision sous le chiffre (nombre de mandats d'une ventilation…). */
  appoint?: ReactNode;
}) {
  const classe = alerte ? 'tuile tuile--alerte' : 'tuile';
  const contenu = (
    <>
      <span className="surtitre">{titre}</span>
      <div className="tuile__valeur">{valeur}</div>
      <div className="tuile__pied">
        {alerte && <span className="tuile__signal">à traiter</span>}
        {appoint && <span>{appoint}</span>}
        {lien && <Icone nom="ouvrir" taille={16} classe="tuile__chevron" />}
      </div>
    </>
  );
  return lien ? (
    <Link to={lien} className={classe}>
      {contenu}
    </Link>
  ) : (
    <div className={classe}>{contenu}</div>
  );
}

/** Grille de tuiles : autant de colonnes que la largeur en admet. */
export function Tuiles({ libelle, children }: { libelle?: string; children: ReactNode }) {
  return (
    <section className="tuiles" aria-label={libelle}>
      {children}
    </section>
  );
}
